import { signal } from "~/sdk/signal";

const selectedSku = signal<string | null>(null);
const setSku = (sku: string | null) => selectedSku.value = sku;

const state = {
  selectedSku,
  setSku,
};

export const useSkuSelector = () => state;
